// src/utils/authHeaders.js
// Helper centralizado para autenticacao em requisicoes ao backend

import { auth } from '../firebase.js';

/**
 * Obtem headers de autenticacao para requisicoes ao backend
 * @returns {Promise<Object>} Headers com Authorization e Content-Type
 */
export const getAuthHeaders = async () => {
  const user = auth.currentUser;
  if (!user) return {};

  const token = await user.getIdToken();
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
};

/**
 * Faz requisicao autenticada ao backend
 * @param {string} url - URL da requisicao
 * @param {Object} options - Opcoes do fetch (method, body, etc)
 * @returns {Promise<Response>} Response do fetch
 */
export const authenticatedFetch = async (url, options = {}) => {
  const headers = await getAuthHeaders();
  return fetch(url, {
    ...options,
    headers: {
      ...headers,
      ...options.headers
    },
    credentials: 'include'
  });
};

/**
 * Faz requisicao GET autenticada
 * @param {string} url - URL da requisicao
 * @returns {Promise<any>} Dados JSON da resposta
 */
export const authenticatedGet = async (url) => {
  const response = await authenticatedFetch(url);
  if (!response.ok) {
    throw new Error(`GET request failed: ${response.status}`);
  }
  return response.json();
};

/**
 * Faz requisicao POST autenticada
 * @param {string} url - URL da requisicao
 * @param {Object} data - Dados a enviar
 * @returns {Promise<any>} Dados JSON da resposta
 */
export const authenticatedPost = async (url, data) => {
  const response = await authenticatedFetch(url, {
    method: 'POST',
    body: JSON.stringify(data)
  });
  if (!response.ok) {
    throw new Error(`POST request failed: ${response.status}`);
  }
  return response.json();
};

/**
 * Faz requisicao PUT autenticada
 * @param {string} url - URL da requisicao
 * @param {Object} data - Dados a enviar
 * @returns {Promise<any>} Dados JSON da resposta
 */
export const authenticatedPut = async (url, data) => {
  const response = await authenticatedFetch(url, {
    method: 'PUT',
    body: JSON.stringify(data)
  });
  if (!response.ok) {
    throw new Error(`PUT request failed: ${response.status}`);
  }
  return response.json();
};

/**
 * Faz requisicao DELETE autenticada
 * @param {string} url - URL da requisicao
 * @returns {Promise<any>} Dados JSON da resposta
 */
export const authenticatedDelete = async (url) => {
  const response = await authenticatedFetch(url, {
    method: 'DELETE'
  });
  if (!response.ok) {
    throw new Error(`DELETE request failed: ${response.status}`);
  }
  return response.json();
};
